/**
 * Use this instead of `!!value`.
 *
 * `!` and `!!` are easy to confuse.
 * Use `exists(value)` when checking that a value exists.
 * Use `!value` when checking that a value does not exist.
 *
 * This makes the intent obvious and avoids accidental `!`/`!!` typos.
 */
export function exists(value: any): boolean {
  // eslint-disable-next-line no-restricted-syntax
  return !!value;
}
